
export const colors = [
'#ffd54f',
'#ff8f00',
'#c62828',
'#4caf50',
'#ffb300',
'#9c27b0',
'#4a148c',
'#ce93d8',
'#ef5350',
'#ef9a9a','#a1887f','#90caf9','#1976d2','#2196f3','#607d8b','#cfd8dc',
];


// WEBPACK FOOTER //
// ./src/config.js